module.exports = __webpack_public_path__ + "static/media/wokindo_2.1afeb064.jpg";